import React, { useCallback } from "react";
import { PaginationContainer } from "../components";
import { Pagination } from "@td/ui";
import { useTasks } from "../contexts/tasks-context";

const ListViewPagination = React.memo(() => {
  const { updateQueryParams, meta: { page, perPage, total }} = useTasks();

  const handlePageChange = useCallback((page) => {
    updateQueryParams({ page });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [updateQueryParams]);

  return (
    <PaginationContainer>
      <Pagination
        activePage={page}
        itemsCountPerPage={perPage}
        totalItemsCount={total}
        onChange={handlePageChange}
      />
    </PaginationContainer>
  );
});

export default ListViewPagination;
